import { useContext, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { AppContext } from "@/contexts/AppContext";
import { ChatPanel } from "./chat-panel/ChatPanel";
import { useChatWidgetState } from "./useChatWidgetState";
import "./AiChatWidget.scss";

export function AiChatWidget() {
  const intl = useIntl();
  const { isChatPanelOpen, openPanel, closePanel } = useChatWidgetState();
  const {
    successMetricMessage: pendingMessage,
    clearSuccessMetricMessage: clearPendingMessage,
  } = useContext(AppContext);
  const toggleButtonRef = useRef<HTMLButtonElement>(null);
  const wasChatPanelOpenRef = useRef(false);

  useEffect(() => {
    if (pendingMessage) {
      openPanel();
    }
  }, [pendingMessage]);

  useEffect(() => {
    if (isChatPanelOpen) {
      document.body.classList.add("chat-open");
    } else {
      document.body.classList.remove("chat-open");
      if (wasChatPanelOpenRef.current) {
        toggleButtonRef.current?.focus();
      }
    }
    wasChatPanelOpenRef.current = isChatPanelOpen;
    return () => {
      document.body.classList.remove("chat-open");
    };
  }, [isChatPanelOpen]);

  return (
    <>
      <ChatPanel
        isOpen={isChatPanelOpen}
        onClose={closePanel}
        pendingMessage={pendingMessage}
        onPendingMessageHandled={clearPendingMessage}
      />
      {!isChatPanelOpen && (
        <button
          id="ai-chat-toggle-btn"
          ref={toggleButtonRef}
          className="tcw-toggle-btn"
          onClick={openPanel}
        >
          <div className="button-text-wrapper">
            <span className="button-text">
              {intl.formatMessage({ id: "app.toolboxChat.toggleButton" })}
            </span>{" "}
          </div>
          <div className="icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
            >
              <g id="sparkleloader">
                <polyline
                  id="star1"
                  points="28.5,1.5 26.6,5.6 22.5,7.5 26.6,9.4 28.5,13.5 30.4,9.4 34.5,7.5 30.4,5.6 "
                ></polyline>
                <polyline points="13.5,6 9.8,14.2 1.5,18 9.8,21.8 13.5,30 17.2,21.8 25.5,18 17.2,14.2 " />
                <polyline
                  id="star2"
                  points="28.5,22.5 26.6,26.6 22.5,28.5 26.6,30.4 28.5,34.5 30.4,30.4 34.5,28.5 30.4,26.6 "
                ></polyline>
              </g>
            </svg>
          </div>
        </button>
      )}
    </>
  );
}
